import queryString from 'query-string'

function castValue(value: any) {
  if (!value) return null

  try {
    return parseInt(value, 10)
  } catch (e) {
    return value
  }
}

function useUrlParams(...params: string[]): {[key: string]: any} {
  const parsed = queryString.parse(window.location.search)

  const hash = {}
  params.forEach(key => {
    hash[key] = castValue(parsed[key])
  })

  return hash
}

export default useUrlParams
